import React from 'react';
import { RxValidateFn } from 'src/core/forms';
import { Text } from 'src/core/forms';
import { useFieldError } from 'src/core/forms';
import classnames from 'classnames';

import classes from './Forms.scss';
import { ErrorFor, ErrorText } from './ErrorFor';

type InputProps = {
    id?: string;
    field?: string;
    label?: string;
    type?: 'text' | 'password' | 'number';
    placeholder?: string;
    validate?: RxValidateFn;
    notify?: string[];
    autoFocus?: boolean;
    required?: boolean;
    disableAutoComplete?: boolean;
    optional?: boolean;
    onChange?: (...args: any[]) => void;
    minLength?: number;
    disabled?: boolean;
    value?: string;
    errorValue?: string;
    autoCapitalize?: 'off' | 'none' | 'on' | 'sentences' | 'words' | 'characters';
    autoCorrect?: 'off' | 'on';
    spellCheck?: boolean;
};

export const Input: React.FC<InputProps> = ({
    label,
    id,
    field,
    placeholder,
    validate,
    type = 'text',
    notify,
    autoFocus,
    required = false,
    disableAutoComplete,
    optional,
    onChange,
    minLength,
    disabled = false,
    value,
    errorValue,
    autoCapitalize,
    autoCorrect,
    spellCheck,
}) => {
    const isNotValid = useFieldError(field || '');
    return (
        <>
            {label && (
                <label
                    htmlFor={id || field}
                    className={classnames({
                        [classes.isNotValid]: isNotValid,
                    })}
                >
                    {label}
                    {required && <span className="required">{' *'}</span>}
                    {optional && <span className="optional">{' (Optional)'}</span>}
                </label>
            )}

            <Text
                field={field || ''}
                id={id || field}
                type={type}
                placeholder={placeholder}
                validate={validate}
                notify={notify}
                autoFocus={autoFocus}
                autoComplete={disableAutoComplete ? 'off' : 'on'}
                onChange={onChange}
                minLength={minLength}
                disabled={disabled}
                value={value}
                autoCapitalize={autoCapitalize}
                autoCorrect={autoCorrect}
                spellCheck={spellCheck}
            />
            {errorValue ? <ErrorText text={errorValue} /> : <ErrorFor field={field || ''} />}
        </>
    );
};
